import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home, Users, Settings, Phone, FileText, Users2, Briefcase } from 'lucide-react';

const Site = () => {
  const siteStructure = {
    'Home': {
      icon: Home,
      color: 'text-blue-600',
      path: '/',
      children: null
    },
    'About Us': {
      icon: Users,
      color: 'text-purple-600',
      path: '/Breakthrough',
      children: {
        'FAQs': { icon: FileText, color: 'text-purple-500', path: '/faq' },
        'Leadership': { icon: Users2, color: 'text-purple-500', path: '/leadership' },
        'Brochures': { icon: FileText, color: 'text-purple-500', path: '/brochures' }
      }
    },
    'Services': {
      icon: Settings,
      color: 'text-green-600',
      path: '/servicepage',
      children: {
        'Our Services': { icon: Briefcase, color: 'text-green-500', path: '/servicepage' },
        'Recent Projects': { icon: Briefcase, color: 'text-green-500', path: '/RecentProject' }
      }
    },
    'Contact Us': {
      icon: Phone,
      color: 'text-red-600',
      path: '/contact',
      children: null
    }
  };

  const HeroSection = () => (
    <div className="bg-gradient-to-r from-red-900 to-purple-800 text-white p-12 rounded-t-lg">
      <h1 className="text-4xl font-bold mb-4">Site Navigation</h1>
      <p className="text-lg opacity-90">Explore our website structure and find exactly what you're looking for.</p>
      <div className="mt-8 grid grid-cols-4 gap-4">
        {Object.entries(siteStructure).map(([key, value]) => (
          <Link 
            to={value.path} 
            key={key} 
            className="text-center p-4 bg-white bg-opacity-10 rounded-lg backdrop-blur-sm hover:bg-opacity-20 transition-all cursor-pointer"
          >
            {React.createElement(value.icon, { size: 24, className: 'mx-auto mb-2' })}
            <span className="text-sm font-medium">{key}</span>
          </Link>
        ))}
      </div>
    </div>
  );

  const renderSiteMap = (structure, level = 0) => {
    return Object.entries(structure).map(([key, value]) => {
      const hasChildren = value.children && Object.keys(value.children).length > 0;
      const Icon = value.icon;

      return (
        <div key={key} className={`ml-${level * 8}`}>
          <Link 
            to={value.path}
            className={`flex items-center py-3 px-4 rounded-lg hover:bg-red-50 transition-colors ${level === 0 ? 'bg-red-50' : ''}`}
          >
            {level > 0 && (
              <div className="w-8 flex justify-center">
                <ChevronRight className="text-red-300" size={16} />
              </div>
            )}
            <Icon className="text-red-900 mr-3" size={20} />
            <span className={`${level === 0 ? 'font-semibold text-lg' : 'text-md'} text-red-900`}>
              {key}
            </span>
          </Link>
          {hasChildren && (
            <div className="ml-4">
              {renderSiteMap(value.children, level + 1)}
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-xl overflow-hidden">
      <HeroSection />
      <div className="p-8 space-y-2">
        {renderSiteMap(siteStructure)}
      </div>
      <div className="bg-red-50 p-6 border-t border-red-100">
        <p className="text-center text-red-900">
          Can't find what you're looking for? 
          <Link to="/contact" className="text-red-700 ml-1 cursor-pointer hover:underline">
            Contact Us.
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Site;